module.exports = {
      id: "custom_design-usage",
      viewBox: "0 0 353.6 342.34",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#custom_design-usage",
      toString: function () {
        return this.url;
      }
    }